
'use strict';

import $ from 'jquery';
import Backbone from 'backbone';
import config from '../config';
import mediator from '../mediator';
import Analytics from '../../components/Analytics/Analytics';
import { EnableAdobeAnalytics } from '../../utilities/featureFlags';

Backbone.$ = $;

var ReferenceDesignBrowseBarView = Backbone.View.extend({

  events: {
    'click .ReferenceDesigns-Browse-bar-filterButton': 'onBrowseButtonClick',
    'change .ReferenceDesigns-Browse-bar-browseDropdown': 'onBrowseDropdownChange',
    'change .ReferenceDesigns-Browse-bar-filter': 'onFilterChange'
  },

  initialize: function(options) {
    this.$dataEl = options.$dataEl;
    // Track reference design marketing event
    if (this.$dataEl && this.$dataEl.length) {
      if (EnableAdobeAnalytics.isEnabled()) {
        this.sendReferenceDesignInfoToAdobe();
      } else {
        this.createReferenceDesignViewEvent();
      }
      this.assignReferenceDesignDownloadHandler();
    }
  },

  collectRefDesignData: function() {
    let currUrl = window.location.href;
    return {
      referenceDesignId: this.$dataEl.data('referenceDesignId'),
      referenceDesignName: this.$dataEl.data('referenceDesignName'),
      referenceDesignUrl: currUrl,
      partId: this.$dataEl.data('partId'),
      partName: this.$dataEl.data('partName'),
      partUrl: this.$dataEl.data('partUrl'),
      partCategory: this.$dataEl.data('category'),
      manufacturer: this.$dataEl.data('manufacturer'),
      forEndProducts: this.$dataEl.data('forEndProducts')
    }
  },

  createReferenceDesignViewEvent: function() {
    let data = this.collectRefDesignData();
    mediator.trigger(config.events.referenceDesigns.view, {
      referenceDesignId: data.referenceDesignId,
      referenceDesignName: data.referenceDesignName,
      referenceDesignUrl: data.referenceDesignUrl,
      productId: data.partId,
      productName: data.partName,
      productUrl: data.partUrl,
      productCategory: data.partCategory,
      manufacturer: data.manufacturer,
      action: 'View'
    });
  },

  assignReferenceDesignDownloadHandler: function() {
    $('.ReferenceDetail-downloadButton').click(() => {
      let data = this.collectRefDesignData();
      mediator.trigger(config.events.referenceDesigns.download, {
        referenceDesignId: data.referenceDesignId,
        referenceDesignName: data.referenceDesignName,
        referenceDesignUrl: data.referenceDesignUrl,
        productId: data.partId,
        productName: data.partName,
        productUrl: data.partUrl,
        productCategory: data.partCategory,
        manufacturer: data.manufacturer,
        action: 'Download'
      });
    })
  },

  onBrowseDropdownChange: function(ev) {
    this.trigger('change:tab', ev.currentTarget.value);
  },

  onBrowseButtonClick: function(ev) {

    var $button = $(ev.currentTarget);

    // Don't do anything if the current button is already active
    if ($button.hasClass('is-active')) return;

    // Deactivate all buttons and activate current one
    this.$('.ReferenceDesigns-Browse-bar-filterButton.is-active').removeClass('is-active');
    $('.ReferenceDesigns-Browse-bar-filterButton').attr('aria-current', 'false');
    $button.addClass('is-active');
    $button.attr('aria-current', 'true');

    // Get category type
    var categoryType = $button.data('category-type');

    // Show the right tab section
    this.trigger('change:tab', categoryType);

  },

  onFilterChange: function(e) {
    this.trigger('change:filter', e.currentTarget.value);
  },

  sendReferenceDesignInfoToAdobe: function() {
    let data = this.collectRefDesignData();
    let referenceDesignInteraction = {
      event: 'referenceDesign_interaction',
      partNumber: data.partName || undefined,
      releasedBy: data.manufacturer || undefined,
      forApplication: data.partCategory || undefined,
      forEndproducts: data.forEndProducts.split(',').filter(Boolean) || undefined
    }
    Analytics.setOnAdobeDataLayer(referenceDesignInteraction);
  },

});

module.exports = ReferenceDesignBrowseBarView;



// WEBPACK FOOTER //
// ./assets/js/reference/ReferenceDesignBrowseBarView.js